import MainPage from "../screens/mainPage.jsx";
import HeaderV2 from "./Header/HeaderV2.jsx";
import HeaderIconBurger from "./Header/HeaderIconBurger.jsx";
import LegacyHeaderGate from "../v2/components/LegacyHeaderGate.jsx";
import { V2_SCREEN_KEYS } from "../v2/registry";

// The home page body, shared by the "/" and "/home" routes. Rendered in place at
// "/" (no redirect) so the query string stays on the URL for silentLogin.
//
// The legacy logo header is suppressed for V2 partners by the gate — the V2 home
// draws its own top bar.
function HomeRoute() {
  return (
    <>
      <LegacyHeaderGate screen={V2_SCREEN_KEYS.HOME}>
        <HeaderV2 leftButton={<HeaderIconBurger />} />
      </LegacyHeaderGate>
      <MainPage />
    </>
  );
}

export default HomeRoute;
